import type { CssObject } from '@wix/thunderbolt-becky-types'

/**
 * Base spx infrastructure vars: the formulas that compute --scaling-factor from
 * the layout atom vars (--spx-stopper-min/max, --section-max-width).
 *
 * Re-declared in any scope that needs --scaling-factor recomputed:
 *   - :root (themeFontsAndColors, so popups inherit base values)
 *   - per-#compId on components that override atom vars (layoutToCss)
 */
export const SPX_VARS_BASE: CssObject = {
	'--full-viewport': '100 * var(--one-unit) * var(--browser-zoom)',
	'--scaling-factor':
		'clamp(var(--spx-stopper-min), var(--full-viewport), min(var(--spx-stopper-max), var(--section-max-width)))',
}
